<script setup lang="ts">
import type { ProductLine } from '~/types/api'

const props = defineProps<{
  line: ProductLine
}>()

const {
  data: files,
  status,
  error: error,
} = await useLazyAsyncData(
  () => createProductLineRepository().getFiles(props.line?.nid),
  {
    transform: (data) => data.items,
  }
)

const toast = useToast()

watch(
  () => error,
  () => {
    if (import.meta.client && error.value) {
      toast.add({
        title: error.value.message,
        color: 'red',
      })
    }
  },
  { immediate: true }
)
</script>

<template>
  <!-- TODO: Add skeleton if necessary -->
  <DownloadWidget
    v-if="status !== 'pending' && Array.isArray(files)"
    :files="files"
    :line-id="line.nid"
    class="bg-white"
    card-background-class="bg-neutral-100"
  />
</template>
